// extracted by mini-css-extract-plugin
module.exports = {"shoppingHeader":"shoppingHeader_shoppingHeader__niK_d"};